import { getCellIndex, getCellsArray, isCellSpaned, isRangeId } from "../helpers/main";
import { IAction, IActionConfig, ISpan, IMuonCell } from "../types";
import { awaitRedraw } from "@dhx/ts-common/dom";
import { compare } from "@dhx/ts-common/core";
import { DataPage } from "@xbs/muon";

export class Merge implements IAction {
	public config: IActionConfig;
	private _newSpan: ISpan;
	private _prevSpan: ISpan[];
	private _prevData: IMuonCell[];

	constructor(config: IActionConfig) {
		this.config = config;
	}

	do() {
		const { cell, spreadsheet, page, $autofill, grid } = this.config;
		if (!cell || !isRangeId(cell as string) || cell?.includes(",")) return;
		const { merged = [] } = page?.getMeta();
		const cells = getCellsArray(cell as string, grid);
		const spans: Set<ISpan> = new Set();
		const pageData = page?.serialize() as IMuonCell[];
		this._prevData = [...pageData];

		//find prev spans
		cells.forEach(c => {
			const span = isCellSpaned(c, merged, grid);
			if (span) {
				spans.add(span);
			}
		});
		const [firstCell, ...rest] = getCellsArray(cell, grid);
		const removedCells = [...rest];
		const lastCell = removedCells[removedCells.length - 1];
		const data = pageData.filter(c => {
			const removed = removedCells.find(rCell => {
				const { row, col } = getCellIndex(rCell, grid);
				return c[0] === row && c[1] === col - 1;
			});
			return !removed;
		});
		const firstIds = getCellIndex(firstCell, grid);
		const lastIds = getCellIndex(lastCell, grid);
		this._newSpan = {
			from: {
				row: firstIds.row,
				column: firstIds.col - 1,
			},
			to: {
				row: lastIds.row,
				column: lastIds.col - 1,
			},
		};
		if (merged.find(span => compare(span, this._newSpan))) return; // return if span already exists
		this._prevSpan = merged.filter(span => spans.has(span)) || [];
		const newMerge: ISpan[] = [...merged.filter(span => !spans.has(span)), this._newSpan]; // remove prev cell spans and add new one
		const scroll = grid?.getScrollState();
		page?.setMeta({ merged: newMerge, scroll });
		if (!$autofill) {
			page?.parse(data);
		}
		(spreadsheet as any)._updateGridState();
	}

	undo() {
		const { page, spreadsheet, $autofill, grid } = this.config;
		const { merged } = page?.getMeta();
		const scroll = grid?.getScrollState();
		page?.setMeta({ scroll, merged: [...merged.filter(span => span !== this._newSpan), ...this._prevSpan] }); // remove created span and return prev spans
		if (!$autofill) {
			page?.parse(this._prevData);
		}
		awaitRedraw().then(() => {
			(spreadsheet as any)._updateGridState();
		});
	}
}
